import FormSection from "../../../common/components/functional/formSection/FormSection";
import { useTranslation } from "react-i18next";
import { TalentCVTable } from "./TalentCVTable";
import { ContentKey } from "../TalentDetails";

type Props = {
  handleOpenEditModal: (content: ContentKey) => void;
};

export const TalentCV = ({ handleOpenEditModal }: Props) => {
  const { t } = useTranslation("talentProfile");
  return (
    <FormSection title={t("talentProfile:CV")} margin>
      <TalentCVTable handleOpenEditModal={handleOpenEditModal} />
    </FormSection>
  );
};
